export default {
  onResize(state) {
    state.isSmallScreen = window.innerWidth < 1200;
  },

  calcSideBarWidth(state, payload) {
    state.sideBarWidth = payload;
  },
};
